import React from 'react'

import { useLanguages } from '@/hooks'

export const Copyright: React.FC = () => {
  const { t } = useLanguages()
  return <div className="copyright">{t('copyright')}</div>
}
